'use client';
/*
 * @providesModule SkillzSVG
 */

// @ts-ignore sdk-mobile dependency
import SkillzImage from 'SkillzImage';
import {source_svgs} from '@sdk-mobile';

type SkillzSVGProps = {
  source: string;
  style: StyleSheet;
};
// returning SKillzImage.web until we have solution for svg
export default function SkillzSVG(props: SkillzSVGProps) {
  // `source_svgs[key]` is the result of `require('./x.svg').default`, which Next may
  // give us either as a StaticImageData object ({src}) OR as a plain URL string
  // depending on the loader. Reading `.src` blindly yields `undefined` in the string
  // case, so the image silently renders nothing (e.g. the BEST-label ribbon, bonus
  // tags, supported-payments strip). Resolve either shape to a usable URL.
  const entry = source_svgs[props.source] as string | {src?: string} | undefined;
  // Fall back to the raw asset name so SkillzImage can still resolve it (bundled raster
  // map / theme / CDN) instead of silently rendering nothing when the SVG map misses.
  const source = (typeof entry === 'string' ? entry : entry?.src) ?? props.source;
  // SVGs are ribbon/label/icon shapes with transparent surrounds — 'contain' shows the
  // whole shape at its aspect; the default 'cover' crops/fills into an opaque block
  // (e.g. the bonus-tag ribbon painting over a deposit tile).
  return <SkillzImage resizeMode='contain' {...props} source={source} />;
}
